export enum UserStatus {
    Created = 'CREATED',
    Validated = 'VALIDATED'
}
